import { ApplicationElement, html } from '@crossiety/lit-components';
import style from './style.lit.css';

/**
 * Sub component of collage component.
 *
 * @prop layout - Different component style (options: static, absolute)
 */

export default class CollageItem extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    layout: { type: String, reflect: true },
  };

  constructor() {
    super();
    this.layout = 'static';
    this.addEventListener('click', () => this.handleClick());
  }

  setImage(img) {
    this.image = img;
  }

  setCursorStyle() {
    this.style.cursor = this.image.dataset.url ? 'zoom-in' : null;
  }

  handleClick() {
    const { url } = this.image.dataset;

    if (url) {
      this.dispatchEvent(
        new CustomEvent('collageItem-click', {
          detail: { realTarget: this },
          bubbles: true,
          composed: true,
        })
      );
    }
  }

  handleSlotChange(e) {
    this.setImage(e.target.assignedElements({ flatten: true })[0]);
    this.setCursorStyle();
  }

  render() {
    return html`<slot @slotchange=${this.handleSlotChange}></slot>`;
  }
}

customElements.get('xs-collage-item') ||
  customElements.define('xs-collage-item', CollageItem);
